import { DatePicker } from 'antd'
import { Form } from 'antd'
import { FC } from 'react'
import { outputDateFormat } from '../../../../../../../../../../constants/constants'
import { requiredDatePickerRules } from '../../../../../../../../../../constants/forms/validation/rules'

interface EstimatedDateProps {}

const EstimatedDate: FC<EstimatedDateProps> = () => {
    const name = 'estimatedDate'

    return (
        <Form.Item name={name} label={'Дата поставки'} rules={requiredDatePickerRules}>
            <DatePicker format={outputDateFormat} />
        </Form.Item>
    )
}

export default EstimatedDate
